import { render } from "./payementSuccess.vue?vue&type=template&id=7639562f&scoped=true"
import script from "./payementSuccess.vue?vue&type=script&lang=js"
export * from "./payementSuccess.vue?vue&type=script&lang=js"

import "./payementSuccess.vue?vue&type=style&index=0&id=7639562f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7639562f"]])

export default __exports__